function buildCartData($activeProduct, $quantity, $product_main, properties, random_no, individuelle) {
  const hiddenProductCount = $activeProduct.find('.hidden_product_input').length;
  const hiddenProducts = [];

  for (let i = 1; i <= hiddenProductCount; i++) {
    const $inputWrap = $activeProduct.find(`#hidden_product_${i}`);
    let variantId;

    if ($inputWrap.hasClass("product-form__input--dropdown")) {
      variantId = $inputWrap.find('select option:selected').data('variantid');
    } else {
      variantId = $inputWrap.find('input:checked').data('variantid');
    }

    if (variantId !== undefined) {

      const properties = {
        'TRIKOT': random_no
      };

      // ✅ Add 'Individuell' only if     
      const isIndividuellInput = $inputWrap.find('input[name="Individuell"]').length > 0;
      if (individuelle && isIndividuellInput) {
        properties['Individuell'] = individuelle;
      }
      
      hiddenProducts.push({
        quantity: $quantity,
        id: variantId,
        properties
      });
    }
  }

  const items = [...hiddenProducts, {
    quantity: $quantity,
    id: $product_main,
    properties
  }];

  return { items };
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      var $submitter = $(evt.submitter);
      var $activeProduct = $submitter.closest('.active-product');
      
      const submitButtonwrap = this.querySelector('.product-form__buttons');
      const submitButton = evt.submitter;
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);
      
      let Geschenkgutscheine = $('.product_Geschenkgutscheine').length;      
      if(Geschenkgutscheine > 0) {
         $('.cart-error-text').text('');
         var Geschenkgutscheine_val = $('.product_Geschenkgutscheine .field__input').val();
         if(Geschenkgutscheine_val){ } else {
            $('.cart-error-text').text('Bitte ergänzen Sie Name des Beschenkten.');
            return false;
         }            
      }

       let Is_Camp_Section = $('.camp-section').length;
       //console.log('Is_Camp_Section',Is_Camp_Section);
       if(Is_Camp_Section > 0) {         
         let count_error = $(evt.submitter).parents('form').find('.product-options-form .error').length;
         let count_hidden_error = $(evt.submitter).parents('form').find(".product-options-form .error[style='display: none;']").length;
         let final_error = count_error - count_hidden_error;
         console.log('error',count_error,'hidden',count_hidden_error);
         if(final_error != 0) {
           return false;
         }
       }
      
       var is_Camp_Product = $(evt.submitter).hasClass("camp_cross_selling_submitter"); 
       //console.log('is_Camp_Product',is_Camp_Product);     
       
            
      var hidden_product = $activeProduct.find('.hidden_product_input').length;  
      const check_trikot_submitter = $submitter.hasClass("trikot-submitter");
      const isIndividuellChecked = $activeProduct.find('input[name="Individuell"]').is(':checked');
      //console.log(hidden_product);
      if(hidden_product > 0 && isIndividuellChecked) {   
            var individuelle = '';
            var individuell_no = $activeProduct.find('#individuell-nummer').val().trim();
            var individuell_name = $activeProduct.find('#individuell-name').val().trim();
      
            if (individuell_no && individuell_name) {
              individuelle = `${individuell_no} ${individuell_name}`;
              $activeProduct.find('.cart-error-text').text('');
            } else if (!individuell_no && !individuell_name) {
              $activeProduct.find('.cart-error-text').text('Bitte ergänzen Sie Nr. & Name für Individuell.');
              evt.preventDefault();
              return false;
            } else if (!individuell_no) {
              $activeProduct.find('.cart-error-text').text('Bitte ergänzen Sie Nr. für Individuell.');
              evt.preventDefault();
              return false;
            } else if (!individuell_name) {
              $activeProduct.find('.cart-error-text').text('Bitte ergänzen Sie Name für Individuell.');
              evt.preventDefault();
              return false;
            }          
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
     
      const formData = new FormData(this.form);
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      if(hidden_product > 0  && check_trikot_submitter) {
        
      var $quantity = $activeProduct.find(".quantity__input").val();
      var $product_main = $activeProduct.find('#product-form-installment').find('[name=id]').val(); 
      var purchase_code = $activeProduct.find('#input-purchase-code').val();      
      let random_no = Math.floor(Math.random() * 100000000);
      let count_is_in_house = $activeProduct.find('.is_in_house__true').length;      
     
      var has_is_in_house = false;
      $activeProduct.find('.hidden_product_input.is_in_house__true').each(function (){
        if($(this).hasClass("product-form__input--dropdown")){          
          var select_val = $(this).find('select').val();
          if(select_val != '0'){            
            has_is_in_house = true;
          }          
        }
        else {
          var input = $(this).find('input');          
          if($(input).prop('checked') == true){            
            has_is_in_house = true;
          }
        }        
      });

      let activeOptions = [];
      $activeProduct.find('.hidden_product_input').each(function (){
        if($(this).hasClass("product-form__input--dropdown")){          
          var select_val = $(this).find('select').val();
          if(select_val != '0'){            
            if (!activeOptions.includes('Spieler')) {
                activeOptions.push('Spieler');
            }
          }          
        }
        else {
          var input = $(this).find('input');          
          if($(input).prop('checked') == true){ 
            const input_name = input.attr('name');
            if (!activeOptions.includes(input_name)) {
                activeOptions.push(input_name);
            }
          }
        }        
      });
      
      let additional_options = activeOptions.join(', ');      
      //console.log("activeOptions",activeOptions,additional_options);
        
      var properties = {};
      if(random_no){
        properties['TRIKOT'] = random_no;
      }
      if(purchase_code){
         properties['purchase-code'] = purchase_code;
      }
      if(count_is_in_house > 0 && has_is_in_house == true){        
         properties['In-house'] = 'Ja';
      }
      if (activeOptions.length > 0) {
         properties['Zusätzlich'] = additional_options;
      }  
      //console.log(properties);      
        
      const data = buildCartData($activeProduct, $quantity, $product_main, properties, random_no, individuelle);      
      console.log(data);
        
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        beforeSend: function() {
          $('.cart-error-text').html('');
        },
        success: function(itemData) { 
         window.location.href = '/cart';       
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.cart-error-text').html(response);
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      });
      
      return false;
      }

      if(is_Camp_Product){
            
            let random_no = $(evt.submitter).parents('form').find("input[name='properties[CAMPID]']").val();            
            var camp_productID = [];
            var properties = {};
            var quantity = 1;
            var camp_items = [];
            
            var this_checked = $(evt.submitter).parents('form').find('.field-crosssell-product input:checkbox:checked');
            $(this_checked).each(function(i){              
              camp_productID[i] = $(this).val();               
            });
            
            if(camp_productID.length > 0){
            $(this_checked).each(function(i){  
                camp_items.push({
                   id: $(this).val(), 
                   quantity: 1,
                   properties: {
                    'CAMPID': random_no
                  }
                });
            });      
                  
            var camp_data = { items: camp_items };
            console.log(camp_data);
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: camp_data,
              beforeSend: function() {                    
              },
              success: function(itemData) {
                
                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                  }
                 
                  setTimeout(() => {
                    window.location.href = '/cart';  
                  }, 300);   
                  
                  let product_id = response.product_id;
                  $('.product-grid .grid__item[data-id="'+product_id+'"]').addClass('product-in-cart');
                  
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  submitButton.classList.remove('loading');
                  submitButton.removeAttribute('aria-disabled');
                  submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
                  if(submitButtonwrap){
                    submitButtonwrap.classList.add('success');                    
                    setTimeout(() => {
                      submitButtonwrap.classList.remove('success');
                    }, 4000);
                  } 
                });
                
              },
              error: function(XMLHttpRequest) {
                var response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;
              }
            });  
            
          }

      }
      else {
        
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }          
         
          if (Is_Camp_Section > 0) {
            window.location.href = '/cart'; 
          }
          else {
            this.cartNotification.renderContents(response);
          }

          if(response.sku == '98821654570'){
            submitButton.classList.add('product_exist');
          }
          let product_id = response.product_id;
          $('.product-grid .grid__item[data-id="'+product_id+'"]').addClass('product-in-cart');
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if(submitButtonwrap){
            submitButtonwrap.classList.add('success');
            
            setTimeout(() => {
              submitButtonwrap.classList.remove('success');
            }, 4000);
          }           
  
        });
        
      }      
      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
